// src/App.js
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ModerationHub from "./Components/moderation/ModerationHub";

// Authentication
import AdminLogin from "./Components/Auth/AdminLogin";


// Dashboard Layout
import DashboardLayout from "./Components/layout/DashboardLayout";

// Dashboard Pages
import OverviewDashboard from "./Components/dashboard/OverviewDashboard";
import UserAnalyticsPage from "./Components/user-analytics/UserAnalyticsPage";
import ContentAnalyticsPage from "./Components/content-analytics/ContentAnalyticsPage";
import ConnectionsAnalyticsPage from "./Components/analytics/ConnectionsAnalyticsPage";
import MessagesAnalyticsPage from "./Components/analytics/MessagesAnalyticsPage";
import CommunitiesAnalyticsPage from "./Components/analytics/CommunitiesAnalyticsPage";
import AdminSettings from "./Components/admin/AdminSettings";
import AIAdvisoryPage from "./Components/ai/AIAdvisoryPage";

// ❗ TEMPORARY BYPASS MODE (enable while building UI)
const BYPASS_AUTH = true;

// Protected Route Logic
function ProtectedRoute({ children }) {
  if (BYPASS_AUTH) return children; // Dev Mode

  // Production Mode
  const adminAccess = sessionStorage.getItem("admin_access");
  if (!adminAccess) return <Navigate to="/admin" replace />;

  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Default redirects */}
        <Route path="/" element={<Navigate to="/admin" replace />} />

        {/* Super Admin Login */}
        <Route path="/admin" element={<AdminLogin />} />

        {/* Dashboard Protected Routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<OverviewDashboard />} />
          <Route path="moderation" element={<ModerationHub />} />
          <Route path="user-analytics" element={<UserAnalyticsPage />} />
          <Route path="content-analytics" element={<ContentAnalyticsPage />} />
          <Route path="connections" element={<ConnectionsAnalyticsPage />} />
          <Route path="messages" element={<MessagesAnalyticsPage />} />
          <Route path="communities" element={<CommunitiesAnalyticsPage />} />
          <Route path="ai-advisory" element={<AIAdvisoryPage />} />
          <Route path="settings" element={<AdminSettings />} />
        </Route>

        {/* Catch-all */}
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
